module.exports = __webpack_public_path__ + "img/material-default.60759802.png";